<div class="new-issue-trigger" [formGroup]="fg">
  <div class="trigger-settings-section">
    <div class="form-group">
      <div class="form-label">
        {{ 'playbooks.aiServices' | labelsProvider }}
      </div>
      <app-multi-select
        [options$]="aiServiceOptions$"
        [placeHolder]="'playbooks.selectAiServices' | labelsProvider"
        (optionOnSelection)="updateMultiSelectControl('aiServices', $event)"
        [selectedIds]="fg.controls['aiServices'].value || []"
      ></app-multi-select>
    </div>

    <div class="form-group">
      <div class="form-label">
        {{ 'playbooks.ruleSeverity' | labelsProvider }}
      </div>
      <app-multi-select
        [options$]="severityOptions$"
        [placeHolder]="'playbooks.selectIssueSeverity' | labelsProvider"
        (optionOnSelection)="updateMultiSelectControl('severity', $event)"
        [selectedIds]="fg.controls['severity'].value || []"
      ></app-multi-select>
    </div>

    <div class="form-group">
      <div class="form-label">
        {{ 'playbooks.taxonomy' | labelsProvider }}
      </div>
      <app-multi-select
        [options$]="taxonomyOptions$"
        [placeHolder]="'playbooks.selectTaxonomy' | labelsProvider"
        (optionOnSelection)="updateMultiSelectControl('taxonomy', $event)"
        [selectedIds]="fg.controls['taxonomy'].value || []"
      ></app-multi-select>
    </div>
  </div>
</div>
